'use client';

import { type ReactNode, Suspense } from 'react';
import {
  AppLayoutGridHeaderArea,
  AppLayoutGridMainArea,
} from '@frameio/app-layout';
import { handleGlobalErrors } from '@frameio/next-shared/utils';
import { AccountLock } from '@frameio/plan-management/account-lock/AccountLock';
import { AppSheet } from '@frameio/primary-nav/components';
import { AppcuesAnchor } from '@frameio/telemetry';

export default function Layout({
  header,
  children,
}: {
  children: ReactNode;
  header: ReactNode;
}) {
  try {
    return (
      <Suspense fallback={null}>
        <AppLayoutGridHeaderArea $isWebClient={false}>
          {header}
        </AppLayoutGridHeaderArea>
        <AppLayoutGridMainArea
          $isBorderEnabled={true}
          $isWebClient={false}
          role="main"
        >
          {children}
          <AppcuesAnchor />
        </AppLayoutGridMainArea>
        <AccountLock />
        <AppSheet />
      </Suspense>
    );
  } catch (e) {
    return handleGlobalErrors(e);
  }
}
